import { SxProps, Theme } from '@mui/material/styles';

export const swatchBoxSX = ({ selected = false }: { selected: boolean }): SxProps<Theme> => ({
	...(selected && {
		borderBottom: '3px solid',
		borderColor: 'grey.500',
		paddingBottom: '5px',
	}),
});

export const swatchSX = ({
	selected = false,
	clickable = false,
	image,
}: {
	selected: boolean;
	clickable: boolean;
	image: string;
}): SxProps<Theme> => ({
	width: '60px',
	height: '60px',
	border: '2px solid',
	borderColor: 'grey.100',
	boxShadow: 'none',
	backgroundRepeat: 'repeat',
	backgroundImage: `url("${image}")`,
	transition: 'border-color 300ms ease-in',
	cursor: clickable ? 'pointer' : 'inherit',

	// swatch size large
	'&.MuiIconButton-sizeLarge': {
		padding: '14px',
	},
	// swatch size medium
	'&.MuiIconButton-sizeMedium': {
		padding: '10px',
	},
	...(clickable && {
		'&:hover': {
			borderColor: 'grey.500',
		},
	}),
	...(selected && {
		borderColor: 'grey.500',
		boxShadow: 'none',
		svg: {
			color: 'text.main',
			fill: 'text.main',
			position: 'absolute',
		},
	}),
});
